module.exports = __webpack_public_path__ + "static/media/iconComplaintActive.3c6a3e8b.svg";